<template>
  <div>
    <el-upload
      :ref="refName"
      :drag="isDrag"
      class="image-upload"
      :action="action"
      :auto-upload="autoUpload"
      :multiple="isMutli"
      :on-change="loadJsonFromFile"
      :on-remove="removeInfo"
      :accept="acceptType"
      :on-exceed="handleExceed"
      :http-request="uploadFile"
      :limit="limitSize"
      :show-file-list="showFile"
      :file-list="fileList"
      :disabled="disabled"
      style="width: 292px; height: 191px"
    >
    </el-upload>
  </div>
</template>
<script>
import oss from "../../plugin/upload/oss.js";
import tools from "../../plugin/tools/tools.js";
import api from "@/config/api.js";
import axios from "axios";
export default {
  name: "upload-audio",
  props: {
    refName: {
      type: String,
      default: "upload",
    },
    limitSize: {
      type: Number,
      default: 1,
    },
    isMutli: {
      type: Boolean,
      default: false,
    },
    isDrag: {
      type: Boolean,
      default: true,
    },
    action: {
      type: String,
      default: "#",
    },
    acceptType: {
      type: String,
      default: ".png,.jpg,.jpeg",
    },
    showFile: {
      type: Boolean,
      default: false,
    },
    autoUpload: {
      type: Boolean,
      default: false,
    },
    maxSize: {
      type: Number,
      default: 4,
    },
    type: {
      type: String,
      default: "pic",
    },
    uploadInfo: {
      type: Object,
      default: () => ({}),
    },
    fileData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileList: this.fileData,
      fileName: "",
      imageData: [],
      avatarUploadInfo: this.uploadInfo, //阿里云上传参数
    };
  },
  // computed: {
  //   ...mapGetters(['imgSearchCount'])
  // },
  created() {
    // console.log(this.fileData);
  },
  methods: {
    // async getInfo() {
    //   const data = await oss.getOssImgUploadSign();
    //   this.avatarUploadInfo = data;
    // },
    async getUploadInfo(params) {
      // const data = await oss.getOssImgUploadSign()
      // this.avatarUploadInfo = data
      let url = api.topURL + "/app-api/tool/v1/get/oss/upload/sign";
      console.log("--------url", url);
      let vm = this;
      $.ajax({
        type: "get", //请求方式
        url: url,
        // jsonp: "callbackparam",
        // dataType: "json",
        contentType: "application/json;utf-8",
        crossDomain: true,
        data: {},
        success: function (result) {
          console.log("------------result", result);
          if (!result) {
            console.log("----请求错误");
            return;
          }
          switch (result.rcode) {
            case "000000":
              const res = result.rdata;
              vm.avatarUploadInfo = {
                OSSAccessKeyId: res.accessid,
                policy: res.policy,
                Signature: res.signature,
                dir: res.dir,
                key: `${res.dir}${tools.getUUID()}`,
                host: res.host,
              };
              if (params) {
                vm.uploadFile(params);
              }
              break;
            case "800001":
              break;
            default:
              console.log("----请求错误");
              vm.$emit("uploadFailed", {});
              break;
          }
          return;
        },
        error: (err) => {
          console.log("-----err", err);
        },
      });
    },
    getFileSuffix(fileName) {
      const suffix = fileName
        .substring(fileName.lastIndexOf("."), fileName.length)
        .toLowerCase();
      return suffix;
    },
    islimitSize(size) {
      if (size / 1024 / 1024 >= this.maxSize) {
        this.$message({
          customClass: "image-message",
          type: "error",
          message: `上传图片大小不能超过${this.maxSize}MB！`,
        });
        return false;
      }
      return true;
    },
    handleExceed(files, fileList) {
      this.$message({
        customClass: "image-message",
        type: "error",
        message: `只能上传一张图片`,
      });
    },
    loadJsonFromFile(file, fileList) {
      const acceptType = this.acceptType;
      this.fileList = [];
      let suffix = this.getFileSuffix(file.name);
      if (acceptType.indexOf(suffix) === -1) {
        this.$message({
          customClass: "image-message",
          type: "error",
          message: `上传文件只能是${acceptType}格式`,
        });
        return false;
      }
      if (!this.islimitSize(file.size)) {
        return false;
      }
      this.fileName = file.name;
      if (this.isMutli) {
        this.fileList = fileList;
      } else {
        this.fileList.push(fileList[fileList.length - 1]);
      }
      //显示那些音乐
      this.fileList.forEach((item) => {
        if (!item.url || item.url.indexOf(".") === -1) {
          item.url = URL.createObjectURL(item.raw);
        }
      });
      if (!this.autoUpload) {
        this.$emit("showFile", { picList: this.fileList, type: this.type });
      }

      // this.$refs.upload.submit()
      this.$refs[this.refName].submit();

      return true;
    },
    removeInfo() {
      // this.$emit('uplodFile');
    },
    removeFile(item) {
      let index = this.fileList.findIndex((info) => {
        info.url === item.url;
      });
      if (index >= 0) {
        this.fileList.splice(index, 1);
      }
    },
    uploadAllFile() {
      this.fileList.forEach((item) => {
        this.uploadFile(item);
      });
    },
    submitUpload() {
      // this.$refs.upload.submit();
      this.$refs[this.refName].submit();
    },
    async uploadFile(params) {
      // console.log('------------fileList', this.fileList[0].url, this.$route)
      console.log("结束了");
      if (!this.avatarUploadInfo || !this.avatarUploadInfo.host) {
        // await this.getInfo();
        this.getUploadInfo(params);
        return;
      }
      console.log("-------啊啊啊", this.avatarUploadInfo);
      const sign = this.avatarUploadInfo;
      const formData = new FormData();
      const file = params.file;
      formData.append("OSSAccessKeyId", sign.OSSAccessKeyId);
      formData.append("policy", sign.policy);
      formData.append("Signature", sign.Signature);
      // sign.dir
      const key =
        "img/records/" + tools.getUUID() + this.getFileSuffix(file.name);
      formData.append("key", key);
      formData.append("file", file);
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      this.$emit("uploading", { file: file, url: this.fileList[0].url });

      let _imgSearchCount = sessionStorage.getItem("imgSearchCount") - 0 || 0;
      axios
        .post(sign.host, formData, config)
        .then(() => {
          // console.log(file.name);
          // this.fileList.forEach(item => {
          //   if (item.uid === file.uid) {
          //     item.url = key;
          //   }
          // });
          // this.$emit('showFile', { picList: this.fileList, type: this.type });
          this.$emit("uploaded", {
            file: file,
            url: `${sign.host}${key}`,
            imgSearchCount: _imgSearchCount,
          });
          // this.$refs.upload.clearFiles();
          this.$refs[this.refName].clearFiles();
        })
        .catch((err) => {
          console.log("-----err", err);
          this.$emit("uploadFailed", {});
        });
    },
  },
  watch: {
    // fileList (val) {
    //   console.log('--------------fileList', val)
    //   console.log('--------$route', this.$route)
    // },
    uploadInfo(newVal) {
      // this.avatarUploadInfo = newVal;
    },
    fileData(newVal) {
      this.fileList = newVal;
    },
  },
};
</script>
<style lang="css" scoped>
/deep/ .image-upload .el-upload-list {
  display: none;
}
/deep/ .image-upload .el-upload--text {
  width: 292px;
  height: 191px;
}
/deep/ .image-upload .el-upload-dragger {
  width: 292px;
  height: 191px;
}
/deep/ .image-upload .el-loading-mask {
  display: none;
}
/deep/ .image-upload .el-upload-dragger:hover {
  border-color: #a28b77;
}
</style>



// WEBPACK FOOTER //
// upload-image.vue?39d8ae18